<template>
  <div class="grid-container text-content">
    <div class="info-metadata">
      <div>
        <b>Quest {{paddingZero(item.questId)}}</b>
        <p><span class="bold">{{subQuestId}}/3</span> - {{item.subQuest[subQuestId-1].name}}</p>
      </div>
      <p>{{item.name}}<br><strong>{{structure.xp}}</strong><small>XP</small></p>
    </div>
    <hr>
    <div v-html="item.subQuest[subQuestId-1].content"/>
  </div>
</template>

<script>
  import QuestStructure from './TasklistPayload/QuestStructure'
  import QuestContent from './TasklistPayload/QuestContent'
  import {paddingZero} from '@/utilities/number'

  export default {
    name: 'lessonsText',
    data() {
      return {
        item: null,
        structure: null,
      }
    },
    computed: {
      questStore() {
        return this.$store.state.questStore
      },
      subQuestId() {
        return this.questStore.lastSavedSubQuestIndex
      },
      currentSubQuest() {
        return this.item.subQuest[this.subQuestId-1]
      },
    },
    created() {
      const id = parseInt(this.$route.params.id)
      this.item = QuestContent[id-1]
      this.structure = QuestStructure[id-1]
    },
    methods: {
      paddingZero
    }
  }
</script>

<style lang="scss" scoped>
  .text-content {
    padding: 1rem;
  }

  .info-metadata {
    display: flex;
    justify-content: space-between;
    align-items: center;

    b {
      font-weight: 900;
      font-size: 1.5rem;
      background: linear-gradient(to bottom right, #6f5da8, #1F2041);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    p {
      background: linear-gradient(to bottom right, #6f5da8, #1F2041);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      text-align: end;
    }
  }
</style>
